import service from '../service.js'

export default {
  /**
   * 获取设备版本
   * @returns 
   */
  GetEquipmentVersionList: () => {
    return service({
      url: '/EquipmentVersion/GetList',
      method: 'get',
    })
  },
}